"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Toolbar = require("./Toolbar");
Object.keys(_Toolbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Toolbar[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Toolbar[key];
        }
    });
});
